<template>
    <modal-frame 
      :isVisible="props.isVisible" 
      :width="props.width" 
      :hegiht="props.height" 
      maxWidth="300px"
      :isOverlay="props.isOverlay"
      customClass="alert_wrap"
      @closeDialogHandler="closeHandler">
        <div class="modal_title alert_title">
            <h4>{{ props.title || $t('trading.common.alert') }}</h4>
            <div v-if="!isBtn" class="close_btn" @click="closeHandler">Close</div>
        </div>
        <div class="modal_body alert_body">
            <p v-html="props.content"></p>
        </div>
        <div class="modal_btn" v-if="isBtn">
            <button @click="closeHandler">{{$t('trading.common.close')}}</button>
        </div>
    </modal-frame>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue';
import ModalFrame from './ModalFrame.vue';
const props = defineProps({
    isVisible: { type: Boolean },
    title: { type: String },
    content: { type: String },
    width: { type: String },
    height: { type: String },
    maxWidth: { type: String },
    isBtn: {
        type: Boolean,
        default: false,
    },
    isOverlay: {
        type: Boolean,
        default: true,
    },
});
const emit = defineEmits(['closeDialogHandler']);

const closeHandler = () => {
    emit('closeDialogHandler');
}

</script>

<style lang="scss" scoped>

.alert_body p{
    text-align: center;
}
</style>